const $ = require('jquery');
const headerAnalytics = require('header.analytics');
const config = {
  headerLogoSelector: '[data-js="hf-logo"]',
};

class HeaderLogo {
  _logInteraction() {
    return headerAnalytics.logEvent(
      'header click',
      ['header', 'logo'].join('>'),
    );
  }

  init() {
    $(config.headerLogoSelector).on('click touchend', this._logInteraction);
  }
}

module.exports = new HeaderLogo();
